import { FC } from 'react'
import { QRCodeCanvas } from 'qrcode.react'

interface BillQRCodeProps {
  qrValue: string
}

const BillQRCode: FC<BillQRCodeProps> = ({ qrValue }) => {
  return <QRCodeCanvas value={qrValue} size={65} />
}

export default BillQRCode
